import dayjs from 'dayjs'
import { createSignal, onMount, createMemo, For } from 'solid-js'
import { Portal } from 'solid-js/web'
import { SearchOutline } from '@/icons'
import { res2json } from '@/utils'

const paymentActions = {
  deposit: '上分',
  withdrawal: '下分'
}

const [rows, setRows] = createSignal([])

export default function Wallets() {
  const playerRows = createMemo(() => rows().filter(e => !e.player.is_robot))
  const robotRows = createMemo(() => rows().filter(e => e.player.is_robot))

  const query = new URLSearchParams(document.location.search)
  const [date, setDate] = createSignal(query.get('date') ?? dayjs().tz('Asia/Chongqing').format('YYYY-MM-DD'))
  const [type, setType] = createSignal(query.get('t') ?? '')
  const [keywords, setKeywords] = createSignal(query.get('k') ?? '')
  const [loading, setLoading] = createSignal(true)

  onMount(() => {
    query.set('date', dayjs(date()).startOf('day').unix())
    query.set('k', keywords())
    fetch(`/api/wallets?${query.toString()}`).then(res2json).then(r => { setRows(r.data ?? []) }).finally(() => { setLoading(false) })
  })

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>上下分记录</li>
          </ul>
        </div>
        <h2 class="text-xl">上下分记录</h2>
        <form class="flex flex-wrap items-center gap-2">
          <label class="flex items-center gap-1"><span class="flex-none">日期:</span><input type="date" name="date" value={date()} onChange={e => setDate(e.target.value)} min={dayjs().tz('Asia/Chongqing').subtract(8, 'day').format('YYYY-MM-DD')} class="input input-bordered flex-1" /></label>
          {/*<select name="t" value={type()} onChange={e => setType(e.target.value)} class="select select-bordered">
            <option value="">全部类型</option>
            <option value="player">玩家</option>
            <option value="robot">机/托</option>
          </select>*/}
          <div class="join">
            <input type="text" name="k" value={keywords()} onChange={e => setKeywords(e.target.value)} class="input input-bordered join-item" placeholder="用户名或昵称" />
            <button type="submit" class="btn join-item"><span class="w-5"><SearchOutline /></span></button>
          </div>
        </form>
        <div class="overflow-x-auto">
          <table class="table whitespace-nowrap">
            <thead>
              <tr class="bg-base-200">
                <th>用户名(昵称)</th>
                <th>类型</th>
                <th>操作</th>
                <th class="text-right">金额</th>
                <th class="text-right">操作时间</th>
              </tr>
            </thead>
            <tbody>
              <For each={playerRows()}>
                {(row) => (
                  <tr class="hover:bg-base-200">
                    <td>{row.player.username}({row.player.nickname})</td>
                    <td>玩家</td>
                    <td>{paymentActions[row.action] ?? row.action}</td>
                    <td class="text-right">{((row.score ?? 0) / 100.).toFixed(2)}</td>
                    <td class="text-right">{row.created_at ? dayjs(row.created_at * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                  </tr>
                )}
              </For>
              <For each={robotRows()}>
                {(row) => (
                  <tr class="bg-sky-50 hover:bg-base-200">
                    <td>{row.player.username}({row.player.nickname})</td>
                    <td>机/托</td>
                    <td>{paymentActions[row.action] ?? row.action}</td>
                    <td class="text-right">{((row.score ?? 0) / 100.).toFixed(2)}</td>
                    <td class="text-right">{row.created_at ? dayjs(row.created_at * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </div>
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}
